import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=2ce2eb4f&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce2eb4f')) {
      api.createRecord('2ce2eb4f', component.options)
    } else {
      api.reload('2ce2eb4f', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=2ce2eb4f&", function () {
      api.rerender('2ce2eb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ym7jp5qO0h0j/JS/comp/CurrentYear.vue"
export default component.exports